<template>
  <div class="scene-info right_cont">
    <el-breadcrumb
      v-if="!embedInRecycle"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">
        {{ $t("breadcrumb.home") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.control") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.scence") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("breadcrumb.scenceMsg") }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="out_bread"
    >
      <div class="scene_main">
        <!-- <img
          src="../../../../assets/img/bg/colors.png"
          alt=""
        > -->
        <vuescroll @handle-scroll="scrollEvent">
          <BaseInfo
            ref="baseInfo"
            :parameters="parameters"
          />
          <TripOption
            v-if="option"
            ref="TripOption"
            :option="option"
          />
          <LightStripSceneCanvas
            v-if="stripDialogInfo.directionType === 3"
            ref="LightStripSceneCanvas"
            :canvas-init-data="canvasInitData"
            :check-device-list="stripDialogInfo.checkDeviceList"
            :get-first-device-id="getFirstDeviceId"
            :mode-type="parameters.modeType"
            @onDeviceActive="onDeviceActive"
            @imgUpdate="onImgUpdate"
            @canvasReady="onCanvasReady"
          />
          <UploadPreview
            v-if="[1, 2].includes(stripDialogInfo.directionType)"
            :canvas-init-data="canvasInitData"
            :strip-dialog-info="stripDialogInfo"
            @imgUpdate="onImgUpdate"
          />
          <TripList
            v-if="stripDialogInfo.checkDeviceList && stripDialogInfo.checkDeviceList.length !== 0"
            ref="TripList"
            :direction-type="stripDialogInfo.directionType"
            :list="stripDialogInfo.checkDeviceList"
            :canvas-init-data="canvasInitData"
            @onSort="onCheckDeviceListSort"
            @onAddLamp="onAddLamp"
            @onTripActive="onTripActive"
          />
          <div
            class="scene_btnList"
          >
            <!-- 取消 -->
            <el-button
              v-if="!embedInRecycle"
              plain
              @click="handlerBack"
            >
              {{ $t('findGateway.cancle') }}
            </el-button>
            <!-- 保存 -->
            <el-button
              v-if="parameters.from !== 'recycle'"
              class="scene_save"
              plain
              :loading="isLoadingSave"
              @click="handlerSaveClick"
            >
              {{ $t('sceneCard.save') }}
            </el-button>
          </div>
        </vuescroll>
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
import BaseInfo from "./BaseInfo.vue";
import TripList from "./TripList";
import {
  getFillOrderFn,
} from "@/page/control-ts/scene/sceneHandle/indexFns";
import {
  Create as reqSaveScene,
  Edit as reqEditScene,
  FindScene,
  SceneRecoverDetail,
  SaveOrUpdateCustomData,
  GetCustomDataList
} from "@/axios/IScene.js";
import { alerterror, alertsuccess } from "@/assets/js/common.js";
import { mergeSceneRouteOpts } from '@/utils/imageSceneRoute';
import UploadPreview from "./UploadPreview.vue";
import LightStripSceneCanvas from './LightStripSceneCanvas';
import DesignCanvas from "@/components/DesignCanvas";
import { transformPointToCXCY } from '@/components/DesignCanvas/utils/common';
import TripOption from './TripOption';

let getSortOrderValue = () => null;
const ActionMap = Object.create(null);
export default {
  components: {
    vuescroll,
    BaseInfo,
    UploadPreview,
    TripList,
    LightStripSceneCanvas,
    TripOption
  },
  props: {
    embedInRecycle: {
      type: Boolean,
      default: false
    },
    embedSceneNo: {
      type: Number,
      default: undefined
    },
    embedGpNo: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      // 弹窗中填写的灯带信息 来自上个路由带过来
      stripDialogInfo: {
        row: 0,
        col: 0,
        directionType: -1, // 横向 1 纵向 2 自定义 3
        checkDeviceList: [],
        CustomGroups: [],
        gpNo: null
      },
      option: null,
      canvasInitData: null,
      parameters: {},
      designCanvasInstance: null, // 用于纵横能力的组件 获取颜色能力
      drawCanvasInstance: null, // 用于自定义的组件 获取颜色信息
      drawInstance: null,
      bgUrl: '', // 图片上传地址
      isLoadingSave: false
    };
  },
  computed: {
    appDocumentWidth() {
      return this.$store.state.appDocumentWidth;
    },
    // effectiveCount() {
    //   let count = 0;
    //   if (this.checkeddata.length > 0) {
    //     this.checkeddata.forEach((n) => {
    //       if (
    //         (n.ActionList && n.ActionList.length > 0) ||
    //         (n.Rules && n.Rules.length > 0)
    //       ) {
    //         count++;
    //       }
    //     });
    //   }
    //   return count;
    // },
  },
  watch: {
    appDocumentWidth(value, oldVal) {
      if (oldVal === value) return;
      getSortOrderValue = getFillOrderFn(value);
      Object.keys(ActionMap).forEach((key) => {
        const arr = ActionMap[key];
        arr.forEach((el) => {
          el.orderId = getSortOrderValue(el.MsgType) || 1;
        });
      });
      // this.checkeddata = [...this.checkeddata]
    },
  },
  created() {
    if (this.embedInRecycle) {
      this.parameters.from = 'recycle';
      this.parameters.SceneNo = this.embedSceneNo;
      this.parameters.GpNo = this.embedGpNo;
      this.requestInfo();
      return;
    }

    const params = mergeSceneRouteOpts(this.$route);

    this.parameters.from = params.from;
    this.parameters.modeType = params.modeType;

    // 复制场景 在进入页面时要借用编辑的逻辑
    if (params.from === 'edit' || params.from === 'copy' || params.from === 'recycle') {
      // 初始化编辑模式查询场景
      this.requestInfo();
    } else {
      this.option = { light: 255 };
      this.initRouteParams();
    }
  },
  methods: {
    requestInfo() {
      const routeOpts = mergeSceneRouteOpts(this.$route);
      const sceneNo = this.embedInRecycle
        ? this.embedSceneNo
        : routeOpts.SceneNo;
      const gpNo = this.embedInRecycle
        ? this.embedGpNo
        : routeOpts.GpNo;

      this.parameters.SceneNo = sceneNo;
      this.parameters.GpNo = gpNo;

      let para = {
        sceneNo
      };

      if (this.parameters.from === 'recycle') {
        SceneRecoverDetail(para, this.initInfo);
        return;
      }

      FindScene(para, this.initInfo);
    },

    async initInfo(res) {
      if (
        res.StatusCode == this.$store.state.rightStatusCode &&
        res.Result
      ) {
        this.parameters = {
          ...this.parameters,
          ConfigStatus: res.Result.ConfigStatus
        };
  
        let totalNum = 0;
        const deviceList = res.Result.DeviceList || [];
        this.parameters.ConfigStatus = res.Result.ConfigStatus;
        if (!!deviceList.length) {
          const ActionList = deviceList[0].ActionList || {};
          const Values = (ActionList[0] || {}).Values || [];
          const totalNumModal = Values.find(item => item.KeyId === 3);

          if (totalNumModal) totalNum = totalNumModal.Value;
        }

        const Mark4Res = await GetCustomDataList({
          projectCode: this.$store.state.projectcode,
          type: 'MatrixScene',
          identifier: this.parameters.SceneNo
        });
        // const { Mark4 } = res.Result;

        const Mark4 = ((Mark4Res?.Result || [])[0] || {}).Content || res.Result.Mark4;

        // const { Mark4 } = res.Result;

        if (!!Mark4) {
          try {
            const MarkRes = JSON.parse(Mark4);
            const { directionType, initData } = MarkRes;
            const option = MarkRes.option || { light: 255 };
            this.bgUrl = initData.bg.url;
            // 已经删除了的设备 线圈不要了
            const delDeviceIds = deviceList.filter(item => !!item.IsDel).map(item => item.VDeviceId);
            const modeData = initData.modeData;

            for (let k in modeData) {
              if (delDeviceIds.includes(k)) delete modeData[k];
            }

            if (directionType === 1) {
              this.stripDialogInfo.row = totalNum;
              this.stripDialogInfo.col = deviceList.length;
            }

            if (directionType === 2) {
              this.stripDialogInfo.row = deviceList.length;
              this.stripDialogInfo.col = totalNum;
            }
            
            this.canvasInitData = {
              ...initData,
              modeData
            };
            
            this.option = option;
            this.stripDialogInfo.directionType = directionType;            
          } catch (e) {

          }
        }

        this.$refs.baseInfo && this.$refs.baseInfo.setFormData({
          SecneName: res.Result.SecneName,
          SceneType: res.Result.SceneType
        });
        
        // 删除的设备放最下面
        this.stripDialogInfo.checkDeviceList = deviceList
          .filter(item => !item.IsDel)
          .concat(
            deviceList.filter(item => !!item.IsDel)
          );
        this.stripDialogInfo.CustomGroups = res.Result.CustomGroups;
        this.stripDialogInfo.gpNo = res.Result.GpNo;
      }
    },

    setImgByDeviceList(deviceList) {
    },
  
    // 初始化路由参数
    initRouteParams() {
      const params = mergeSceneRouteOpts(this.$route);

      if (
        (!params ||
        !params.row ||
        !params.col) &&
        params.directionType !== 3
      ) {
        this.$router.push({
          name: 'control'
        });
      };

      this.stripDialogInfo = {
        ...params,
      };

      const controlAche = getLocalStoragItem("control") || '{}';

      try {
        const ache = JSON.parse(controlAche);

        this.parameters = {
          ...this.parameters,
          ...ache
        };
      } catch (e) {
        console.log('e', e);
      }

    },
    // 编辑模式查询场景
    async initFindScene() {
      const controlAche = getLocalStoragItem("control") || '{}';

      try {
        const params = JSON.parse(controlAche);

        this.parameters = {
          ...this.parameters,
          ...params
        };

        if (params.SceneNo) {
          const res = await FindScene({
            sceneNo: params.SceneNo
          });

          this.handlerFindScene(res);
        }
      } catch (e) {
        console.log('e', e);
      }
    },

    // 查询场景回调
    handlerFindScene(res) {
      if (
        res.StatusCode !== this.$store.state.rightStatusCode ||
        !res.Result
      ) {
        return
      };

      this.parameters.GpNo = res.Result.GpNo;
      this.parameters.ConfigStatus = res.Result.ConfigStatus;
      this.parameters.ParentAreaNames = res.Result.ParentAreaNames;
      // this.scenlist = rs.Result;
      // this.nameValue = this.scenlist.SecneName;
      // this.selectvalue = this.scenlist.SceneType;

      // this.groupSiftValue = "";
      // this.groupSiftOptions = [];
      // if (rs.Result.CustomGroups != null) {
      //   this.groupSiftOptions = rs.Result.CustomGroups;
      // }

      // this.skuSiftValue = "";
      // this.skuSiftOptions = [];
      // this.addcheckdata(this.scenlist.DeviceList);
    },
  
    // 上移 下移
    onCheckDeviceListSort(newList) {
      this.stripDialogInfo.checkDeviceList = newList;
      this.$forceUpdate();
    },

    // 图片上传
    onImgUpdate({ bgUrl, designCanvasInstance, drawCanvasInstance }) {
      this.bgUrl = bgUrl;

      if (designCanvasInstance) {
        this.designCanvasInstance = designCanvasInstance
      }
      
      if (drawCanvasInstance) {
        this.drawCanvasInstance = drawCanvasInstance
      }
    },

    // canvas组件就位
    onCanvasReady(drawCanvasInstance) {
      this.drawCanvasInstance = drawCanvasInstance;
    },

    onCanvasImgUpdate(drawInstance) {
      this.drawInstance = drawInstance;
      this.$refs.TripList.resetValues();
    },

    onDeviceActive(VDeviceId) {
      this.$refs.TripList && this.$refs.TripList.setActiveKey(VDeviceId);
    },

    handlerSaveClick() {
      if (this.parameters.from === 'edit') {
        this.reqEdit();
      } else {
        // 复制场景 在保存时要借用新增的逻辑
        this.reqSave();
      }
    },
    
    // 取消按钮
    handlerBack() {
      this.$router.push({
        path: '/control'
      })
    },

    // 校验上传保存或者编辑
    verifyCanSave() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this.stripDialogInfo;

      if (!baseInfo.nameValue) {
        return {
          status: false,
          message: this.$t('scene.plhode1'),
        }
      };

      const isCustom = this.stripDialogInfo.directionType === 3;

      if (isCustom) {
        const lampCountInput = this.$refs.TripList.values;
        let isLampCountCanSubmit = true;

        if (!this.drawCanvasInstance) {
          return {
            status: false,
            message: this.$t('visual.please') + this.$t('visual.uploadImg')
          }
        }

        for (let i = 0; i < checkDeviceList.length; i++) {
          const { VDeviceId, IsDel } = checkDeviceList[i];

          // 删除设备不校验
          if (!!IsDel) continue;

          const lampCountStr = `${lampCountInput[VDeviceId]}`;

          if (lampCountStr.includes(',')) {
            const lampCount = lampCountStr.split(',').map(item => Number(item) || 0).reduce((a, b) => a + b);

            if (Number.isNaN(lampCount) || lampCount > 500) {
              isLampCountCanSubmit = false;
              break;
            }
          } else if (
              Number.isNaN(Number(lampCountStr)) ||
              Number(lampCountStr) === 0 || 
              Number(lampCountStr) > 500
            ) {
              isLampCountCanSubmit = false;
              break;
            }
        }

        if (!isLampCountCanSubmit) {
          return {
            status: false,
            message: this.$t('sceneCard.lightTripInputLampCount') + '1-500'
          }
        }
      } else if (!this.designCanvasInstance) {
          return {
            status: false,
            message: this.$t('visual.uploadImg')
          }
        }

      return {
        status: true
      }
    },

    // 点击保存
    async reqSave() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { GpNo } = this.parameters;
      const { checkDeviceList, CustomGroups } = this.stripDialogInfo;
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }

      try {
        this.isLoadingSave = true;

        const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);
  
        const Mark4 = this.getMark4();

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          Mark4: ''
        }
        const res = await reqSaveScene(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
      } finally {
        this.isLoadingSave = false;
      }
    },

    // 点击保存且编辑
    async reqEdit() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList, CustomGroups} = this.stripDialogInfo;
      const { GpNo, SceneNo } = this.parameters;
      const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);
      const Mark4 = this.getMark4();
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }
  
      try {
        this.isLoadingSave = true;

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          SceneNo: SceneNo,
          Mark4: ''
        }
        // console.log('reqParams', reqParams);
        // return;
        const res = await reqEditScene(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
      } finally {
        this.isLoadingSave = false;
      }
    },

    /* 提交数据 接口返回处理
     * rs 接口返回数据包
     */
     functionDoNotice(rs) {
      if (rs.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);

        this.$router.push({
          path: '/control'
        })
        // if (rs.Result) {
        //   // this.removecurrent.push({ sceneNo: rs.Result });
        //   // this.courseDialog = true;
        // } else {
        //   this.gopage();
        // }
      } else {
        alerterror(this, rs.StatusCode);
      }
    },

    onAddLamp(deviceId, lampCount, lampInfoList) { 
      this.$refs.LightStripSceneCanvas && this.$refs.LightStripSceneCanvas.addLamp(deviceId, lampCount, lampInfoList)
    },

    onTripActive(deviceId) {
      this.$refs.LightStripSceneCanvas && this.$refs.LightStripSceneCanvas.setCurLineLayerIndex(deviceId);
    },

    getFirstDeviceId() {
      const checkDeviceList = this.stripDialogInfo.checkDeviceList;

      return (checkDeviceList[0] || {}).VDeviceId;
    },

    // 滚动事件
    scrollEvent(e) {

    },

    // 处理选择的设备
    async handlerCheckDeviceList(checkDeviceList) {
      const { row, col, directionType } = this.stripDialogInfo;  // 1 横向 2 纵向
      const isCustom = this.stripDialogInfo.directionType === 3;
    
      const newCheckDeviceList = [];

      if (isCustom && this.drawCanvasInstance === null) return;
      if (!isCustom && this.designCanvasInstance === null) return;

      const option = this.$refs.TripOption.getValue();
      const canvasData = isCustom ? this.drawCanvasInstance.getColors() : await this.designCanvasInstance.getAsyncInstacneData();
      console.log('option', option.light);

      checkDeviceList.filter(item => !item.IsDel).forEach((item, index) => {
        let totalNum = 0;

        switch (this.stripDialogInfo.directionType) {
          case 1:
            totalNum = Number(row);
            break;
          case 2:
            totalNum = Number(col);
            break;
          // 3直接在下面处理
        }

        let lightCxCyStr = '';
        let isCanSubmit = false;
  
        if (isCustom) {
          // 自定义
          const deviceRgbData = canvasData[item.VDeviceId];

          if (Array.isArray(deviceRgbData)) {
            deviceRgbData.forEach(lampData => {              
              const rgba = lampData.rgba || '';
              const rgbaList = rgba.split(',') || [];
              // const CxCy = DesignCanvas.transRgbToCxCy(
              //   Number(rgbaList[0]), 
              //   Number(rgbaList[1]), 
              //   Number(rgbaList[2])
              // );
              // const light = ('0' + Number(option.light).toString(16)).slice(-2);

              // lightCxCyStr += `${light}${CxCy}`;
              const CxCy = transformPointToCXCY({
                color: `${ Number(rgbaList[0])},${Number(rgbaList[1])},${Number(rgbaList[2])},255`,
                light: option.light,
                mode: 'V1'
              }, this.matrixValueUi);

              lightCxCyStr += CxCy;
            })

            totalNum = deviceRgbData.length;
          } else {
            totalNum = 0;
          }
        } else {
          // 纵向横向
          for (let i = 0; i < totalNum; i++) {
            const originImgData = canvasData.originImgData;
            const x = directionType === 1 ? i : index;
            const y = directionType === 1 ? index : originImgData.height  - 1 - i;
            const curXyzDataIndex = y * totalNum + x;
            const curXyzData = canvasData.XYZ_List[curXyzDataIndex];

            // const isBgColorByXYZ = this.designCanvasInstance.isBgColorByXYZ(curXyzData);
            // const light = DesignCanvas.getLightData(curXyzData);
            // console.log('curXyzDatacurXyzData', curXyzData);

            const CxCy = DesignCanvas.transXYZtoCxCy(curXyzData);
            // console.log('curXyzDatacurXyzData', CxCy);
            // console.log('curXyzDataIndex', x, y, curXyzDataIndex);
            // console.log('curXyzDataIndex', curXyzData, isBgColorByXYZ);
            lightCxCyStr += `${Number(option.light).toString(16)}${CxCy}`;
          };
        }

        const curValue = [{
          KeyId: 0, // Channel
          Value: 0,
        }, {
          KeyId: 1, // Mode
          Value: 2,
        }, {
          KeyId: 2, // StartAddr
          Value: 0,
        }, {
          KeyId: 3, // TotalNum
          Value: totalNum
        }, {
          KeyId: 4,
          Value: lightCxCyStr
        }];

        // getLight
        const newActionList = {
          MsgType:  "0x13010000",
          // Channel: 0,
          // Mode: 2,
          // StartAddr: 1,
          // TotalNum: directionType === 1 ? Number(row) : Number(col),
          Values: curValue, // [{KeyId: 1, Value: 1}], // curValue
        }

        newCheckDeviceList.push({
          AreaName: item.AreaName,
          ChannelId: item.ChildId,
          DeviceName: item.DeviceName,
          VDeviceId: item.VDeviceId,
          Mac: item.Mac,
          ActionList: [ newActionList ] // item.ActionList.concat([ newActionList ])
        });
    });

      console.log('newCheckDeviceList', checkDeviceList);
      console.log('newCheckDeviceList', newCheckDeviceList);
      console.log('newCheckDeviceList ==============================');

      return newCheckDeviceList;
    },

    getMark4() {
      const directionType = this.stripDialogInfo.directionType;
      const option = this.$refs.TripOption.getValue();
      const Mark4 = {
        directionType,
        initData: null,
        option 
      }

      if (directionType === 3) {
        if (this.drawCanvasInstance) {
          Mark4.initData = this.drawCanvasInstance.getSaveData() || {};

          console.log('Mark4.initData', Mark4.initData);

          if (!!this.bgUrl) {
            Mark4.initData.bg.url = this.bgUrl;
          }
        }
      } else {
        Mark4.initData = {
          bg: {
            url: this.bgUrl
          }
        }
      }

      return JSON.stringify(Mark4);
    }
  },
};
</script>

<style lang="scss" scoped>
.scene_main {
  display: flex;
  position: absolute;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  height: 92%;
  background: #fefefe;

  ::v-deep  .scene_title {
    display: flex;
    margin-bottom: 24px;
  }

  ::v-deep .scene_container {
    padding: 20px 45px;
    border: solid 1px #e0e3e6;
  }

  .scene_btnList {
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;
  }

  .scene_save {
    background-color: #002a91 !important;
    color: #fff !important;

    &:hover {
      background-color: #002a91 !important;
      color: #fff !important;
    }
  }
}
</style>
